import { openAuthModal } from '../../repositories/header-frontend/v2/open-auth-modal/helpers';
import { IMicrofrontendsAPI } from '../../repositories/header-frontend/v2/open-auth-modal/types';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      openAuthModal,
    },
  };
}
